import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SnackService } from "app/shared/services/snack-service.service";
import { environment } from "environments/environment";
import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";
import { ActivityInfos } from "../models/activity_infos.model";
import { safeFirstValueFrom } from "../../../shared/utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class ActivityInfosService {
  private _activityInfosSaving$ = new BehaviorSubject<boolean>(false);
  private _activityInfosSaved$ = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private snackService: SnackService,
  ) {}

  private _currentActivityInfos$ = new BehaviorSubject<ActivityInfos>(null);

  get currentActivityInfos$(): Observable<ActivityInfos> {
    return this._currentActivityInfos$.asObservable();
  }

  async loadActivityInfos() {
    const activityInfos = await firstValueFrom(this.loadActivityInfos_());
    this._currentActivityInfos$.next(activityInfos);
  }

  loadActivityInfos_() {
    return this.http.get<ActivityInfos>(`${environment.api()}/activity_infos/`);
  }

  save_(a: ActivityInfos) {
    return this.http.post<ActivityInfos>(
      `${environment.api()}/activity_infos`,
      a,
    );
  }

  loadSupportedLangs(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.api()}/activity_infos/supported-langs`);
  }

  async save(a: ActivityInfos) {
    this._activityInfosSaving$.next(true);
    this._activityInfosSaved$.next(false);
    const savedActivityInfos = await safeFirstValueFrom(
      this.http.post<ActivityInfos>(`${environment.api()}/activity_infos`, a),
    );
    this._activityInfosSaving$.next(false);
    this._activityInfosSaved$.next(true);
    this._currentActivityInfos$.next(savedActivityInfos);
    this.snackService.success(`Informations enregistrées`);
    return savedActivityInfos;
  }
}
